import { Diagnostics } from './Diagnostics'

export function DiagnosticsLogger(source, prefix) {
  function withPrefix(message) {
    if (prefix) {
      return `[${prefix}] ${message}`
    } else {
      return message
    }
  }

  function record(message, metaData = {}, level) {
    Diagnostics.record({
      message: withPrefix(message),
      metadata: { source, ...metaData },
      level
    })
  }

  function info(message, metaData) {
    record(message, metaData, 'info')
  }

  function warn(message, metaData) {
    record(message, metaData, 'warning')
  }

  function error(message, metaData) {
    record(message, metaData, 'error')
  }

  async function debug(message, metaData) {
    if (!(await Diagnostics.inDebugMode())) return
    record(message, metaData, 'info')
  }

  return {
    info,
    error,
    warn,
    debug
  }
}
